import blog from "../assets/projects_images/blog.png";
import dashboard from "../assets/projects_images/dashboard.png";
import myQuotes from "../assets/projects_images/my-quotes.png";
import redux from "../assets/projects_images/redux.png";
import userAuth from "../assets/projects_images/user-auth.png";
import jobapp from "../assets/projects_images/jobForm.png";
import flipper from "../assets/projects_images/flipper.png";
const data_projects = [
  {
    name: "Blogger",
    image: blog,
    deployed_url: "https://blogger-ui.herokuapp.com/",
    github_url: "https://github.com/Lovejotsaini/Blogger",
  },

  {
    name: "User Authentiction",
    image: userAuth,
    deployed_url: "https://ecstatic-carson-da6e85.netlify.app/",
    github_url: "https://github.com/Lovejotsaini/notes-user-authentication",
  },

  {
    name: "user-job-app",
    image: jobapp,
    deployed_url: "https://github.com/Lovejotsaini/user-job-application",
    github_url: "https://github.com/Lovejotsaini/user-job-application",
  },

  {
    name: "Billing App",
    image: dashboard,
    deployed_url: "https://billingappbylovejot.netlify.app/",
    github_url: "https://github.com/Mj-Techs/Customer-Dashboard",
  },

  {
    name: "My Quotes Handle",
    image: myQuotes,
    deployed_url: "https://my-quotes-handle.herokuapp.com/",
    github_url: "https://github.com/Lovejotsaini/Quotes-handle",
  },

  {
    name: "my first redux app",
    image: redux,
    deployed_url: "https://first-redux-app.herokuapp.com/",
    github_url: "https://github.com/Mj-Techs/first-redux-application",
  },

  {
    name: "breaking-bad",
    image: flipper,
    deployed_url: "!#",
    github_url: "https://xenodochial-archimedes-509bc9.netlify.app/",
  },
];

export default data_projects;
